<section class="gb_sectionhero">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>
          <sup>{{'section.search.labels.welcome' | translate}}</sup>
          {{'section.search.labels.welcomeSup' | translate}}
        </h1>
      </div>
      <div class="col-md-6">
        <div class="gb_card">
          <h2>{{'section.search.labels.description' | translate}}</h2>
          <section class="card_content">
            <form>
              <label class="card_label_content" for="ricerca">{{'section.search.labels.search.description' | translate}}</label>
              <div class="gb_inputcontainer position-relative">
                <input type="search" placeholder="{{'section.search.labels.search.placeholder' | translate}}" spellcheck="true" name="termSearch"
                  [(ngModel)]="termSearch" tabindex="0" />
                <button [disabled]="termSearch.length < 3"
                  type="submit" title="{{'generic.buttons.search' | translate}}"
                  attr.aria-label="{{'section.search.labels.search.button' | translate}}"
                  class="gb-button-reset" role="button"
                  (click)="goToSearch()" (keypress)="goToSearch()">
                  <span aria-hidden="true">
                    <svg viewBox="0 0 360.7 360.8">
                      <path
                        d="M357.6,342.4l-87.7-87.7c23.5-27,37.8-62.3,37.8-100.9C307.7,69,238.6,0,153.8,0C69,0,0,69,0,153.8s69,153.8,153.8,153.8
  c38.6,0,73.8-14.2,100.9-37.8l87.7,87.7c2.1,2.1,4.9,3.2,7.6,3.2c2.7,0,5.5-1,7.6-3.2C361.8,353.4,361.8,346.6,357.6,342.4
  M21.5,153.8c0-73,59.4-132.2,132.2-132.2c73,0,132.2,59.4,132.2,132.2s-59.3,132.3-132.2,132.3C80.9,286.2,21.5,226.8,21.5,153.8" />
                    </svg>
                    <span class="gb-hidden-visually gb-speak">{{'generic.buttons.search' | translate}}</span>
                  </span>
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <div class="col-md-6">
        <div class="gb_card paga_ora_section">
          <h2>{{'paynow-page-title' | translate}}</h2>
          <section>
            <label class="card_label_content">{{'paynow-page-subtitle-homepage' | translate}}</label>
            <div class="gb_inputcontainer position-relative">
              <button type="button" class="btn btn-primary paga_ora_button" [routerLink]="['/paynow/pay']">
                <i class="fas fa-bars"></i> {{ "generic.buttons.payNow" | translate }}
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</section>
